/**
 * Defines how an estimation scale contributes to scheduling calculations
 */
export enum SchedulingPhase {
  /**
   * Upstream phase - work done before the lot/functionality development
   * (e.g., Cadrage, Architecture, Design)
   */
  Upstream = 0,

  /**
   * Development phase - core development work
   * (e.g., IHM, Backend, Development)
   * Included in functionality duration calculation for Gantt
   */
  Development = 1,

  /**
   * Downstream phase - work done after development
   * (e.g., Tests, Paramétrage, Recette, Mise en production)
   */
  Downstream = 2
}

/**
 * Get display label for scheduling phase
 */
export function getSchedulingPhaseLabel(phase: SchedulingPhase): string {
  switch (phase) {
    case SchedulingPhase.Upstream:
      return 'Amont'
    case SchedulingPhase.Development:
      return 'Développement'
    case SchedulingPhase.Downstream:
      return 'Aval'
    default:
      return 'Inconnu'
  }
}

/**
 * Get description for scheduling phase
 */
export function getSchedulingPhaseDescription(phase: SchedulingPhase): string {
  switch (phase) {
    case SchedulingPhase.Upstream:
      return 'Travail en amont (Cadrage, Architecture, Design)'
    case SchedulingPhase.Development:
      return 'Développement (IHM, Backend, Dev) - utilisé pour le calcul de durée'
    case SchedulingPhase.Downstream:
      return 'Travail en aval (Tests, Recette, Mise en prod)'
    default:
      return ''
  }
}

/**
 * Get all scheduling phase options for selects
 */
export function getSchedulingPhaseOptions() {
  return [
    { value: SchedulingPhase.Upstream, label: getSchedulingPhaseLabel(SchedulingPhase.Upstream), description: getSchedulingPhaseDescription(SchedulingPhase.Upstream) },
    { value: SchedulingPhase.Development, label: getSchedulingPhaseLabel(SchedulingPhase.Development), description: getSchedulingPhaseDescription(SchedulingPhase.Development) },
    { value: SchedulingPhase.Downstream, label: getSchedulingPhaseLabel(SchedulingPhase.Downstream), description: getSchedulingPhaseDescription(SchedulingPhase.Downstream) }
  ]
}
